import FloatingLabelInputGroup from './FloatingLabelInputGroup';
import { MinusCircle    } from 'lucide-react';

const FloatingLabelInputGroupWithButton = ({ inputs, handleClick, buttonLabel, loading }) => {
  return (
    <div className="input-button-group">
      <div className="inputs-container">
          <FloatingLabelInputGroup inputs={inputs} />
      </div>
      <div className="button-container">
        <>
          {!loading &&
            <button onClick={handleClick} className="modal-button cancel-modal-button" style={{ display: "flex", justifyContent: "center", alignItems: "center",padding: "8px 16px"}}>
              {buttonLabel === '-' ? <MinusCircle   size={20} /> : buttonLabel}
            </button>
          }
          {loading && <div className="loading-spinner"></div>}
        </>
      </div>
    </div>
  );
};

export default FloatingLabelInputGroupWithButton;